var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormButton',{attrs:{"variant":_vm.ButtonVariants.SECONDARY,"icon":_vm.IconEnums.TRASH,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.deleteDeadline(_vm.item)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }